import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';


@Injectable({ providedIn: 'root' })
export class StoreDataService {
    private _dataParams: any = {}

    dataParams$ = new BehaviorSubject(null);

    constructor() { }

    get dataParams(): any {
        return this._dataParams;
    }
    set dataParams(data: any) {
        this._dataParams = data
        this.dataParams$.next(data);
    }
}
